var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 11.3353H11.9997C9.42234 11.3353 7.33301 9.24595 7.33301 6.66862C7.33301 4.09129 9.42234 2.00195 11.9997 2.00195H17.333V11.3353Z",
    fill: "#E64A19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 20.6683H11.9997C9.42234 20.6683 7.33301 18.579 7.33301 16.0016C7.33301 13.4243 9.42234 11.335 11.9997 11.335H16.6663V20.6683Z",
    fill: "#7C4DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 30.0023C9.42234 30.0023 7.33301 27.9129 7.33301 25.3356C7.33301 22.7583 9.42234 20.6689 11.9997 20.6689H16.6663V25.3356C16.6663 27.9129 14.577 30.0023 11.9997 30.0023Z",
    fill: "#66BB6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 11.3353H16.667V2.00195H21.3337C23.911 2.00195 26.0003 4.09129 26.0003 6.66862C26.0003 9.24595 23.911 11.3353 21.3337 11.3353Z",
    fill: "#FF7043"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 20.6683C23.911 20.6683 26.0003 18.579 26.0003 16.0016C26.0003 13.4243 23.911 11.335 21.3337 11.335C18.7563 11.335 16.667 13.4243 16.667 16.0016C16.667 18.579 18.7563 20.6683 21.3337 20.6683Z",
    fill: "#29B6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.75ed9456fbde5759fdaeda1cb9529842.svg";
export { ForwardRef as ReactComponent };